const src = import.meta.ROLLUP_FILE_URL_i2ywl_YzKp2MjtOEr7ngzA;
export default {
  src,
  srcSet: src + " " + 1590 + "w",
  width: 1590,
  height: 884,
};